import { FieldInfo } from "@alch/ui";
import { SelectField, SimpleToggleGroup } from "@components/ui";
import { useController } from "react-hook-form";
import ComposerParamLabel from "./ComposerParamLabel.js";
import type { ComposerParamComponentProps } from "./index.js";

const ComposerEnumParam = ({
  param,
  control,
  name,
}: ComposerParamComponentProps<"string">) => {
  const { field, fieldState } = useController({ control, name });

  const items =
    param.enum?.map((item) => ({
      label: String(item),
      value: item,
    })) || [];

  return (
    <div>
      <ComposerParamLabel param={param} />

      {items.length > 5 ? (
        <SelectField
          className="mt-2 first:mt-0"
          control={control}
          name={name}
          items={items}
        />
      ) : (
        <SimpleToggleGroup
          className="mt-2 first:mt-0"
          type="single"
          value={String(field.value)}
          onValueChange={(value) => field.onChange(value || null)}
          items={items}
        />
      )}

      <FieldInfo
        errorMessage={fieldState.error?.message}
        description={undefined}
      />
    </div>
  );
};

export default ComposerEnumParam;
